<template>
  <div class="shop-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">手机号</span>
        <el-input v-model="phoneNumber" placeholder="请输入手机号"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">选择地区</span>
        <el-cascader v-model="addCity" :options="options" :props="{ value: 'code', label: 'name' }" placeholder="请选择地区"></el-cascader>
      </div>
      <div class="condition-wrap">
        <el-button @click="findShop()" type="primary">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button type="success" @click="showAddPop(1)">
          <i class="el-icon-plus"></i>
          新增店铺
        </el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" row-key="shopId" border stripe>
      <el-table-column prop="shopId" label="店铺ID" width="80" align="center"></el-table-column>
      <el-table-column prop="phoneNumber" label="手机号" width="140"></el-table-column>
      <el-table-column prop="shopName" label="店名" width="140"></el-table-column>
      <el-table-column prop="username" label="用户名" width="120"></el-table-column>
      <el-table-column label="地区">
        <template slot-scope="scope">{{ scope.row.provinceName }} - {{ scope.row.cityName }} - {{ scope.row.areaName }}</template>
      </el-table-column>
      <el-table-column prop="detailAddress" label="详细地址"></el-table-column>
      <!-- <el-table-column prop="userId" label="用户ID" width="100" align="center"></el-table-column> -->

      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="320" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="showPswPop(scope.row.shopId, scope.row.userId, scope.row.username)">修改密码</el-button>
          <el-button size="mini" type="primary" plain @click="shopDetail(scope.row.shopId, scope.row.userId)">查看详情</el-button>

          <el-button size="mini" type="primary" plain @click="editShop(scope.row.shopId, scope.row.userId, 2)">店铺修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination background :page-count="totalPage" :current-page="pageNum" @current-change="currentChange" layout="prev, pager, next, jumper"></el-pagination>
    </div>

    <el-dialog :title="actionType === 1 ? '新增店铺' : '修改信息'" :visible.sync="showDlg" width="580px">
      <el-form :model="form" size="small" label-width="100px">
        <el-form-item label="店铺名称">
          <el-input v-model="form.shopName" :disabled="actionType === 2" placeholder="店名提交成功后不能修改"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="form.phoneNumber" placeholder="请输入正确的手机号码"></el-input>
        </el-form-item>

        <el-form-item label="区域">
          <el-cascader v-model="citylist" :options="options" :props="{ value: 'code', label: 'name' }" style="width: 300px" ref="cityCs" placeholder="选择地区"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="form.detailAddress" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="form.username" autocomplete="off" placeholder="请输入登录账号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" v-show="actionType === 1">
          <el-input v-model="form.password" autocomplete="off" placeholder="请输入登录密码"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option v-for="item in statusData" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户权限" v-if="form.roleId">
          <el-select v-model="form.roleId" placeholder="请选择">
            <el-option v-for="item in roleData" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
				<div v-show="form.roleId === '4'">
					<el-form-item label="入驻商家">
						<!-- <el-input v-model="form.companyName" autocomplete="off" placeholder="请输入公司名称"></el-input> -->
            <el-autocomplete
              v-model="form.companyName"
              :fetch-suggestions="queryCompany"
              placeholder="请输入并选择商家"
              hide-loading
              @select="handleSelectCompany"
            ></el-autocomplete>
            <span style="color:red; font-size:12px">注：需要搜索并下拉选择</span>
					</el-form-item>
					<!-- <el-form-item label="品牌logo">
						<div v-if="!editimgup && form.brandLogoUrl">
							<img :src="form.brandLogoUrl + '?x-oss-process=image/resize,w_200'" width="100" style="vertical-align: middle" />
							<el-button size="small" type="text" @click="editimgup = true">修改图片</el-button>
						</div>
						<el-upload v-else class="upload-demo" :action="ossUrl" :data="ossData" :limit="1" :file-list="filelist" :on-success="uploaded" :on-change="uploadCg" list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">图片大小不能超过20MB</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="联系人">
						<el-input v-model="form.contacter" autocomplete="off" placeholder="请输入联系人"></el-input>
					</el-form-item> -->
				</div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showDlg = false">取 消</el-button>
        <el-button type="primary" @click="addShop">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="店铺详情" :visible.sync="showDetail" width="500px">
      <el-form :model="form" size="small" label-width="100px">
        <el-form-item label="店铺名称">{{ form.shopName }}</el-form-item>
        <el-form-item label="手机号码">{{ form.phoneNumber }}</el-form-item>
        <el-form-item label="区域">{{ form.provinceName }} / {{ form.cityName }} / {{ form.areaName }}</el-form-item>
        <el-form-item label="详细地址">{{ form.detailAddress }}</el-form-item>
        <el-form-item label="登录账号">{{ form.username }} &emsp; | &emsp; 店铺ID {{ form.userId }}</el-form-item>
        <el-form-item label="状态">{{ form.status === 1 ? '启用' : '禁用' }}</el-form-item>
        <el-form-item label="用户权限">{{ getRoleStr(form.roleId) }}</el-form-item>
				<div v-show="form.roleId === '4'">
					<el-form-item label="入驻商家">
						{{form.companyName}}
					</el-form-item>
					<!-- <el-form-item label="品牌logo">
						<div v-if="form.brandLogoUrl">
							<img :src="form.brandLogoUrl + '?x-oss-process=image/resize,w_200'" width="100" style="vertical-align: middle" />
						</div>
					</el-form-item>
					<el-form-item label="联系人">
						{{form.contacter}}
					</el-form-item> -->
				</div>
        <el-form-item label="创建时间">{{ form.createTime }}</el-form-item>
        <el-form-item label="更新时间">{{ form.updateTime }}</el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改用户密码" :visible.sync="showPsw" width="500px">
      <el-form :model="pswInfo" size="small" label-width="100px">
        <el-form-item label="店铺ID">{{ pswInfo.shopId }}</el-form-item>
        <el-form-item label="登录账号">{{ pswInfo.userName }}</el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="pswInfo.password" placeholder="请输入新的密码" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showPsw = false">取 消</el-button>
        <el-button type="primary" @click="updatePsw">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '../lib/API'
export default {
  name: 'OrderList',
  data() {
    return {
      addCity: [],
      citylist: [],
      options: [],
      pageNum: 1,
      tableData: [],
      phoneNumber: '',
      totalPage: 0,
      showDlg: false,
      showDetail: false,
      showPsw: false,
			actionType: 0,
			ossUrl: '',
			ossData: {},
			editUpload: false,
			editimgup: false,
			filelist: [],
      roleData: [
        {
          label: '管理员',
          value: '2'
        },
        {
          label: '加盟商',
          value: '3'
        },
        {
          label: '品牌商',
          value: '4'
        },
        {
          label: '品牌商-初级',
          value: '6'
        }
      ],
      statusData: [
        {
          label: '启用',
          value: 1
        },
        {
          label: '禁用',
          value: 0
        }
      ],
      originForm: {
        shopName: '',
        detailAddress: '',
        roleId: '3',
        username: '',
        status: 1,
        password: '',
				phoneNumber: '',
				companyName: '',
        companyId: '',
				brandLogoKey: '',
				contacter: '',
				brandLogoUrl: ''
      },
      form: {},
      pswInfo: {
        shopId: 0,
        userName: '',
        password: ''
      },
      editShopName: '',
      editUserName: '',
      editPhoneNumber: ''
    }
  },
  computed: {
    provinceCode() {
      return this.citylist[0] || ''
    },
    cityCode() {
      return this.citylist[1] || ''
    },
    areaCode() {
      return this.citylist[2] || ''
    },
    addprovinceCode() {
      return this.addCity[0] || ''
    },
    addcityCode() {
      return this.addCity[1] || ''
    },
    addareaCode() {
      return this.addCity[2] || ''
    }
  },
  methods: {
		getOsspop() {
      new API(this).POST({
        url: '/oss/getSignature',
        params: {
          count: 1,
          type: 6
        },
        cb: res => {
          this.ossUrl = res.url
          this.ossData = res.signatures[0]
        }
      })
		},
		uploadCg(file) {
      let ext = file.raw.type
      ext = ext ? '.' + ext.split('/')[1] : ''
      let hasExt = this.ossData.key.indexOf('.')
      if (hasExt === -1) {
        this.ossData.key += ext
      } else {
        this.ossData.key = this.ossData.key.slice(0, hasExt)
        this.ossData.key += ext
      }

      this.editUpload = true
    },
    getRoleStr(roleId) {
      let data = this.roleData.find(item => item.value == roleId)
      return data ? data.label : ''
    },
    showAddPop(type) {
			this.form = Object.assign({}, this.originForm)
			this.filelist = []
      this.actionType = type
      this.showDlg = true
			this.citylist = []
			this.editimgup = true
			
			this.ossUrl = ''
      this.ossData = {}
      this.getOsspop()
		},
		uploaded() {
			this.form.brandLogoKey = this.ossData.key
    },
    currentChange (val) {
      this.pageNum = val
      this.findShop()
    },
    findShop(val) {
      // if (!isNaN(val)) {
      //   this.pageNum = val
      // }
      // console.log(val)
      // console.log(this.addCity)
      // if (val === 'search') {
      //   if (!this.addCity.length) {
      //     console.log('true')
      //     return
      //   } else {
      //     this.pageNum = 1
      //   }
      // }

      let formData = {}

      formData = {
        areaCode: this.addareaCode,
        cityCode: this.addcityCode,
        count: true,
        pageNum: this.pageNum,
        pageSize: 10,
        provinceCode: this.addprovinceCode,
        phoneNumber: this.phoneNumber
      }
      // else {
      //   formData = {
      //     areaCode: this.areaCode,
      //     cityCode: this.cityCode,
      //     count: true,
      //     pageNum: this.pageNum,
      //     pageSize: 10,
      //     provinceCode: this.provinceCode
      //   }
      // }

      // 获取加盟商列表
      new API(this).POST({
        url: '/shop/findShopList',
        params: formData,
        cb: res => {
          let { total, result, pages } = res
          this.totalPage = pages
          this.tableData = result
        }
      })
    },
    handleSelectCompany(item) {
      if (item.id === -1){
        this.form.companyId = ''
        this.form.companyName = ''
      }
      this.form.companyId = item.id
    },
    queryCompany(queryString, cb) {
      if (!queryString) {
        return cb([])
      }
      new API(this).POST({
        url: "/company/listWithPage",
        params: {
          count: true,
          pageNum: 1,
          pageSize: 100,
          name: queryString,
        },
        cb: res => {
          let { pages, result } = res;
          result.forEach(item => {
            item.value = item.name
          })
          if (!result.length) {
            result = [{value: '无匹配数据', id: -1}]
          }
          cb(result)
        }
      });
    },
    editShop(shopId, userId, type) {
			this.getOsspop()
			this.editUpload = false
			this.editimgup = false
			this.filelist = []

      // 编辑店铺
      new API(this).POST({
        url: '/shop/getShopDetail',
        params: {
          shopId,
          userId
        },
        cb: res => {
          this.actionType = type

          this.citylist = [res.provinceCode, res.cityCode, res.areaCode]

          this.editShopName = res.shopName
          this.editUserName = res.username
          this.editPhoneNumber = res.phoneNumber

					this.form = Object.assign({}, res)
          setTimeout(() => {
            this.showDlg = true
          }, 200)
        }
      })
    },

    shopDetail(shopId, userId) {
      new API(this).POST({
        url: '/shop/getShopDetail',
        params: {
          shopId,
          userId
        },
        cb: res => {
          this.showDetail = true
          Object.assign(this.form, res)
        }
      })
    },

    addShop() {
      // 新增商家
      let { shopName, detailAddress, username, password, phoneNumber } = this.form

      if (this.actionType === 1) {
        if (!shopName || !detailAddress || !username || !password || !phoneNumber || !this.citylist.length) {
          this.$message.error('请将店铺信息填写完整~')
          return
        }
      } else {
        if (!shopName || !detailAddress || !username || !phoneNumber || !this.citylist.length) {
          this.$message.error('请将店铺信息填写完整~')
          return
        }
      }

      if (!/^1[3456789]\d{9}$/.test(phoneNumber)) {
        this.$message.error('手机号码格式有误')
        return
      }

      let cityName = this.$refs['cityCs'].presentText

      cityName = cityName.replace(' ', '')
      cityName = cityName.split('/')

      let cityObj = {
        provinceCode: this.citylist[0],
        cityCode: this.citylist[1],
        areaCode: this.citylist[2],
        provinceName: cityName[0],
        cityName: cityName[1],
        areaName: cityName[2]
      }

			let formData = Object.assign({}, this.form, cityObj)
			

			if(this.actionType !== 1) {
				if (formData.username === this.editUserName) {
					delete formData.username
				}
				if (formData.shopName === this.editShopName) {
					delete formData.shopName
				}
	
				if (formData.phoneNumber === this.editPhoneNumber) {
					delete formData.phoneNumber
				}
			}

      let apiurl = this.actionType === 1 ? '/shop/addShop' : '/shop/updateShop'

      new API(this).POST({
        url: apiurl,
        params: formData,
        cb: json => {
          if (json === null) {
            this.showDlg = false
            this.findShop()
          }
        }
      })
    },
    showPswPop(id, userId, name) {
      this.pswInfo.shopId = id
      this.pswInfo.userId = userId
      this.pswInfo.userName = name
      this.showPsw = true
    },
    updatePsw() {
      if (!this.pswInfo.password) {
        this.$message.error('请输入密码~')
        return
      }

      new API(this).POST({
        url: '/user/updatePassword',
        params: this.pswInfo,
        cb: res => {
          if (res === null) {
            this.$message.success('修改成功')
            this.showPsw = false
          }
        }
      })
    }
  },
  created() {
    // 获取地区数据
    new API(this).POST({
      url: '/pca/findPcaList',
      cb: res => {
        this.options = res
      }
    })
    // 查找店铺
    this.findShop()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShopList.vue